export const mapDataForChangesRow = original => {
	const currentItem = {
		agentId: original?.current?.agent_id,
		agentName: original?.current?.agent_name,
		agentOfficeId: original?.current?.agent_office_id,
		agentOfficeName: original?.current?.agent_office_name,
		scheduleAid: original?.current?.schedule_a_id,
		scheduleANumber: original?.current?.schedule_a_number,
		splitProfileId: original?.current?.split_profile_id,
		splitProfileNumber: original?.current?.split_profile_number,
	};
	const newItem = {
		agentId: original?.new?.agent_id,
		agentName: original?.new?.agent_name,
		agentOfficeId: original?.new?.agent_office_id,
		agentOfficeName: original?.new?.agent_office_name,
		scheduleAid: original?.new?.schedule_a_id,
		scheduleANumber: original?.new?.schedule_a_number,
		splitProfileId: original?.new?.split_profile_id,
		splitProfileNumber: original?.new?.split_profile_number,
	};
	return { currentItem, newItem };
};
